import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AlertSliceState {
  showRemediationSaveAlert: boolean;
  showAssessorFindingsAlert: boolean;
  newQuestionInclusionAlerts: Record<string, boolean>;
  showRemediationValidationAlert: boolean;
  showTPNAdminAssignedAlert: boolean;
}

const initialState: AlertSliceState = {
  showRemediationSaveAlert: false,
  showAssessorFindingsAlert: false,
  showRemediationValidationAlert: false,
  showTPNAdminAssignedAlert: false,
  newQuestionInclusionAlerts: {},
};

const alertSlice = createSlice({
  name: 'alertSlice',
  initialState,
  reducers: {
    setShowRemediationSaveAlert(state, action: PayloadAction<boolean>) {
      state.showRemediationSaveAlert = action.payload;
    },
    setShowTPNAdminAssignedAlert(state, action: PayloadAction<boolean>) {
      state.showTPNAdminAssignedAlert = action.payload;
    },
    setShowAssessorFindingsAlert: (state, action: PayloadAction<boolean>) => {
      state.showAssessorFindingsAlert = action.payload;
    },
    setShowRemediationValidationAlert(state, action: PayloadAction<boolean>) {
      state.showRemediationValidationAlert = action.payload;
    },
    setNewQuestionInclusionAlert(
      state,
      action: PayloadAction<{ questionId: string; visible: boolean }>,
    ) {
      const { questionId, visible } = action.payload;
      state.newQuestionInclusionAlerts[questionId] = visible;
    },
    clearNewQuestionInclusionAlerts(state) {
      state.newQuestionInclusionAlerts = {};
    },
  },
});

export const {
  setShowRemediationSaveAlert,
  setShowTPNAdminAssignedAlert,
  setShowAssessorFindingsAlert,
  setNewQuestionInclusionAlert,
  setShowRemediationValidationAlert,
  clearNewQuestionInclusionAlerts,
} = alertSlice.actions;

export default alertSlice.reducer;
